import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from 'firebase/firestore';
import { db } from '../../../firebase/config';
import { uploadImagesAndSaveRecords } from '../../ImageSubmission/uploadForm';
import { deleteImagesFunction } from '../../../firebase/functions';
import '../../StaffGallery/StaffGallery.css';
import { allMonths } from '../CalendarEditor';
import { getNewYorkTimeZoneDate } from '../../../utils/dayjsUs';
const CalendarTemplate = ({
  facilityId,
  claims,
  calendarTemplateImages,
  userUid,
  setCalendarTemplateImages,
  setIsLoading,
  getCalendarImages,
  facilityData,
  setFacilityData,
  month,
}) => {
  const [open, setOpen] = useState(false);
  const [openSelect, setOpenSelect] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]); // State to hold multiple images
  const [imagePreviewUrls, setImagePreviewUrls] = useState([]); // State to hold image preview URLs
  const [selectedMonth, setSelectedMonth] = useState(
    getNewYorkTimeZoneDate().format('MMMM'),
  );
  const [selectedImage, setSelectedImage] = useState(null);

  // Handle dialog open
  const handleOpenDialog = () => {
    setOpen(true);
  };

  // Handle dialog close
  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedImages([]); // Reset image selection on close
    setImagePreviewUrls([]); // Reset previews on close
  };
  const handlClosechosedImage = () => {
    setOpenSelect(false);
    if (
      calendarTemplateImages.length > 0 &&
      facilityData?.calendarTemplateImageId
    ) {
      // Update selected image
      setSelectedImage(
        calendarTemplateImages.find(
          (img) => img.id === facilityData?.calendarTemplateImageId,
        ),
      );
    }
  };
  // Handle image selection (multiple)
  const handleImageSelect = (event) => {
    const files = Array.from(event.target.files); // Convert FileList to an array
    setSelectedImages(files);

    // Generate preview URLs for each selected image
    const previewUrls = files.map((file) => URL.createObjectURL(file));
    setImagePreviewUrls(previewUrls);
  };

  // Handle save action
  const handleSave = async () => {
    if (selectedImages.length > 0) {
      handleCloseDialog();
      setIsLoading(true);
      await uploadImagesAndSaveRecords(
        {
          type: 'calendarTemplate',
          month: selectedMonth,
        },
        selectedImages,
        facilityId,
        userUid,
      );
      getCalendarImages();
      setIsLoading(false);
    } else {
      console.log('No images selected');
    }
  };

  const handlSaveSelectedImages = async (deletedImage) => {
    setIsLoading(true);

    try {
      if (selectedImage) {
        // Check if facility document with the given facilityId exists
        const facilityQuery = query(
          collection(db, 'facilities'),
          where('facilityId', '==', facilityId),
          where('month', '==', month),
        );
        const querySnapshot = await getDocs(facilityQuery);

        if (!querySnapshot.empty) {
          // Facility exists, update the document
          querySnapshot.forEach(async (doc) => {
            const facilityDocRef = doc.ref;
            await updateDoc(facilityDocRef, {
              calendarTemplateImage:
                selectedImage && !deletedImage ? selectedImage.imageUrl : null,
              calendarTemplateImageId:
                selectedImage && !deletedImage ? selectedImage.id : null,

              month,
            });
          });
        } else {
          // Facility doesn't exist, create a new one
          await addDoc(collection(db, 'facilities'), {
            facilityId: facilityId,
            calendarTemplateImage:
              selectedImage && !deletedImage ? selectedImage.imageUrl : null,
            calendarTemplateImageId:
              selectedImage && !deletedImage ? selectedImage.id : null,

            month,
          });
        }
      }
      setFacilityData({
        ...facilityData,
        calendarTemplateImage:
          selectedImage && !deletedImage ? selectedImage.imageUrl : null,
        calendarTemplateImageId:
          selectedImage && !deletedImage ? selectedImage.id : null,
      });
    } catch (error) {
      console.error('Error updating facility:', error);
    } finally {
      setIsLoading(false);
      setOpenSelect(false);
    }
  };

  const handleChooseImage = (id) => {
    if (!selectedImage) {
      setSelectedImage(calendarTemplateImages.find((img) => img.id === id));
    } else {
      setSelectedImage(null);
    }
  };
  const deleteSelectedImages = async () => {
    setOpenSelect(false);
    const imageUrls = [selectedImage?.imageUrl];

    if (
      !window.confirm(
        `Are you sure you want to delete the ${imageUrls.length} images you have selected below? This action is irreversible!`,
      )
    ) {
      return;
    }

    setIsLoading(true);
    try {
      await deleteImagesFunction({
        imageUrls: imageUrls,
        deleteFromFirestore: true,
      });

      // Filter out deleted images from local state
      setCalendarTemplateImages(
        calendarTemplateImages.filter(
          (img) => !imageUrls.includes(img.imageUrl),
        ),
      );

      // Check if the deleted image ID matches any facility document
      const facilityQuery = query(
        collection(db, 'facilities'),
        where('calendarTemplateImage', '==', imageUrls[0]),
      );

      const querySnapshot = await getDocs(facilityQuery);

      // Update all matching documents
      const updatePromises = querySnapshot.docs.map((doc) => {
        const facilityDocRef = doc.ref;
        return updateDoc(facilityDocRef, {
          calendarTemplateImage: null,
          calendarTemplateImageId: null,
        });
      });

      // Wait for all updates to complete
      await Promise.all(updatePromises);

      // Clear the selected image if it was one of the deleted images
      if (imageUrls.includes(selectedImage?.imageUrl)) {
        setSelectedImage(null);
      }

      if (imageUrls.includes(facilityData?.calendarTemplateImage)) {
        handlSaveSelectedImages(true);
      }
    } catch (error) {
      // Handle error (optional)
      // setErrorAlert(error.message || 'Failed to delete images');
    } finally {
      setIsLoading(false);
    }
  };
  const disabledCheckbox = (id) => {
    if (id === selectedImage?.id || !selectedImage) {
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    // Update selected image
    setSelectedImage(
      calendarTemplateImages.find(
        (img) => img.id === facilityData?.calendarTemplateImageId,
      ),
    );
  }, [facilityData, facilityId, calendarTemplateImages]);
  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          paddingTop: '12px',
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          Template:
        </Typography>
        <Box
          sx={{
            display: 'flex',
            width: 'auto',
            height: '100%',
            gap: 2,
            alignItems: 'start',
            padding: '14px 0',
            borderBottom: '4px solid black',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              width: '30%',
              height: '100%',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Button
              variant="contained"
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 'bold',
                fontSize: 20,
                width: '100%',
              }}
              onClick={() => setOpenSelect(true)}
            >
              Modify
            </Button>
            {claims?.superadmin && (
              <Button
                variant="contained"
                onClick={handleOpenDialog}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 'bold',
                  fontSize: 20,
                  width: '100%',
                }}
              >
                Upload
              </Button>
            )}
          </Box>
          {facilityData && (
            <Box
              sx={{
                flexDirection: 'column',
                gap: 1,
                width: '70%',
                height: '100%',
              }}
            >
              {facilityData?.calendarTemplateImage && (
                <img
                  src={facilityData?.calendarTemplateImage}
                  alt={`Selected Calendar Template`}
                  style={{
                    width: '100%',
                    height: '100%',
                    maxHeight: '300px',
                    objectFit: 'contain',
                  }}
                />
              )}
            </Box>
          )}
        </Box>
      </Box>
      {/* Select Image Template Dialog */}
      <Dialog open={openSelect} onClose={handlClosechosedImage}>
        <DialogTitle>Select Image Template</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              paddingTop: 2,
            }}
          >
            {selectedImage && claims.superadmin && (
              <IconButton
                aria-label="delete image"
                onClick={deleteSelectedImages}
                sx={{
                  backgroundColor: '#004B8D',
                  color: 'white',
                  width: '150px',
                  borderRadius: 2,
                  fontSize: 25,
                  '&:hover': {
                    backgroundColor: '#808080',
                  },
                }}
              >
                <DeleteIcon />
                Delete
              </IconButton>
            )}
          </Box>
          <hr />
          <ImageList cols={3} variant="masonry" id="galleryContainer">
            {calendarTemplateImages.length > 0 ? (
              Array.from(calendarTemplateImages).map((img, index) => (
                <ImageListItem key={index}>
                  <img
                    src={img.imageUrl}
                    srcSet={img.imageUrl}
                    alt={img.residentId}
                    loading="lazy"
                    style={{
                      width: '100%',
                      height: '100%',
                      transition: 'opacity 0.4s ease',
                      opacity: selectedImage?.id === img.id ? 0.8 : 1,
                      ...(disabledCheckbox(img.id) ? { opacity: 0.2 } : {}),
                    }}
                  />
                  <Checkbox
                    checked={selectedImage?.id === img.id}
                    onChange={() => handleChooseImage(img.id)}
                    disabled={disabledCheckbox(img.id)}
                  />
                </ImageListItem>
              ))
            ) : (
              <Typography
                variant="h8"
                sx={{
                  fontWeight: 'light',
                  ml: 1,
                  display: 'block',
                  width: '300px',
                }}
              >
                No Images For This Month
              </Typography>
            )}
          </ImageList>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', mb: 2 }}>
          <Button onClick={handlClosechosedImage}>Cancel</Button>
          <Button
            onClick={() => handlSaveSelectedImages(false)}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {/* Upload Template Dialog */}
      <Dialog open={open} onClose={handleCloseDialog}>
        <DialogTitle>Upload Image Templates</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Image previews */}
            {imagePreviewUrls.length > 0 && (
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                  gap: 2,
                  mt: 2,
                }}
              >
                {imagePreviewUrls.map((url, index) => (
                  <img
                    key={index}
                    src={url}
                    alt={`Selected ${index}`}
                    style={{
                      maxWidth: '100px',
                      maxHeight: '100px',
                      borderRadius: '8px',
                      objectFit: 'cover',
                    }}
                  />
                ))}
              </Box>
            )}
            <Button variant="contained" component="label">
              Select Images
              <input
                type="file"
                accept="image/*"
                hidden
                multiple
                onChange={handleImageSelect} // Handle multiple image selection
              />
            </Button>
            <FormControl sx={{ minWidth: '200px' }}>
              <InputLabel id="selectLabel" shrink={true}>
                Select Month
              </InputLabel>
              <Select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                displayEmpty
                inputProps={{ 'aria-label': 'Resident selector' }}
                sx={{ height: '46px' }}
                labelId="selectLabel"
                label=" Change To Resident"
              >
                {allMonths.map((month, index) => (
                  <MenuItem key={index} value={month}>
                    {month}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button
            disabled={selectedImages.length === 0}
            onClick={handleSave}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

CalendarTemplate.propTypes = {
  facilityId: PropTypes.string,
  claims: PropTypes.object,
  calendarTemplateImages: PropTypes.array,
  userUid: PropTypes.string,
  setCalendarTemplateImages: PropTypes.func,
  setIsLoading: PropTypes.func,
  getCalendarImages: PropTypes.func,
  facilityData: PropTypes.object,
  setFacilityData: PropTypes.func,
  month: PropTypes.string,
};
export default CalendarTemplate;
